import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DeviceList as DeviceListComponent } from '@imprivata/nucleus';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import LogoutStyled from '../shared/LogoutStyled';
import { push } from 'redux-first-history';

import './DeviceList.scss';

/**
 * Displays a list of the currently enrolled IID Mobile Devices for the logged in user.
 *
 * @export
 * @class DeviceList
 * @extends {Component}
 */

export class DeviceList extends Component {
  /**
   * The allowed properties for the DeviceList component
   * @param {array} devices - available devices to list
   */

  static propTypes = {
    // is it used ? I dont think so
    deviceString: PropTypes.string,
    deviceList: PropTypes.arrayOf(PropTypes.object),
    useCustomUX: PropTypes.bool,
  };
  static defaultProps = {
    // fixed error, if there was no deviceList provided, would crash
    deviceList: [
      {
        displayName: 'There are no devices to show',
        serialNumber: '',
      },
    ],
    useCustomUX: false,
  };

  returnToIID = () => {
    if (this.props.modality === 'iid-manual'){
      this.props.changeModality(this.props.modality, 'iid');
    }
    else {
      this.props.changeModality(this.props.modality, this.props.modality);
    }
  };

  buildDeviceList = () => {
    let builtList = [];
    this.props.deviceList.forEach(device => {
      builtList.push({ displayName: device.displayName, serialNumber: device.serialNumber, });
    });
    return builtList;
  };


  render() {
    const {
      authenticationToken,
      deviceList,
      moveOn,
      startDeviceManagementWorkflow,
      useCustomUX,
    } = this.props;

    const headerDescription = authenticationToken !== null ? deviceList[0].displayName + ' can now be used for authentication' : '';
    const headerType = authenticationToken !== null ? 'Success-Header-Box' : 'Header-Box';
    const devices = authenticationToken !== null ? deviceList : this.buildDeviceList();
    const logoutStyle = useCustomUX ? 'black' : 'white';
    const logoutComponent = authenticationToken !== null ? null : <LogoutStyled type={logoutStyle} />;
    const headerTitle = authenticationToken !== null ? 'New device added' : 'Manage devices';
    const continueLink = authenticationToken !== null? <btn onClick={moveOn}>Done</btn> : <btn onClick={this.returnToIID}>Done</btn>;
    const enrollDeviceLink = authenticationToken !== null? null : startDeviceManagementWorkflow;

    return (
      <div className='content-body'>
        <DeviceListComponent
          headerType={headerType}
          devices={devices}
          logoutComponent={logoutComponent}
          headerTitle={headerTitle}
          continueLink={continueLink}
          headerDescription={headerDescription}
          enrollDeviceLink={enrollDeviceLink}
          useCustomUX={useCustomUX}
        />
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  const {
    availableModalities, authenticationToken, lastFourDigits, modality, moreOptionsChooseModality, serverState, deviceList, useCustomUX,
  } = state.login;
  return {
    availableModalities,
    lastFourDigits,
    modality,
    moreOptionsChooseModality,
    serverState,
    deviceList,
    authenticationToken,
    useCustomUX,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    moveOn: () => {
      dispatch(actions.endIgnoreTimeout() );
      dispatch(actions.submitAfterSSDM() );
    },
    changeModality: (fromModality, toModality) => {
      dispatch(actions.endDeviceManagementSession() );
      dispatch(actions.changeModality(fromModality, toModality) );
      dispatch(actions.endIgnoreTimeout() );
    },
    // startDeleteDevice: (device, epcsStatus) => {

    // },
    startDeviceManagementWorkflow: () => {
      dispatch(actions.startDeviceManagementSession() );
      dispatch(actions.startIgnoreTimeout() );
      dispatch(actions.moreOptionsChooseModality(false) );
      dispatch(push('/choosemodality') );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DeviceList);
